import request from '../utils/RequestUtil';

function simulate(params) {
  return request({
    url: '/deposito/simular',
    data: {
      monto: params.amount,
      plazo: params.timeLimit,
      tipo: params.depositType
    },
    method: 'POST'
  });
}

function list() {
  return request({
    url: '/deposito',
    method: 'POST'
  });
}

function getById(id) {
  return request({
    url: '/deposito/detalle',
    data: {
      id
    },
    method: 'POST'
  });
}

function signOn(params) {
  return request({
    url: '/deposito/invertir',
    data: {
      cuentaDestino: params.accountIn,
      cuentaOrigen: params.accountOut,
      numeroSimulacion: params.simulationId,
      email: params.email,
      value: params.value
    },
    method: 'POST'
  });
}

function liquidate(params) {
  return request({
    url: '/deposito/liquidar',
    data: {
      numeroDeposito: params.id,
      cuentaDestino: params.account,
      email: params.email
    },
    method: 'POST'
  });
}

export { simulate, list, getById, signOn, liquidate };
